// extracted by css-extract-rspack-plugin
export default {"wrapper":"AuctionBuilderPage-module__wrapper--SFjEI"};